'use client';

// Root-layout error boundary — shared @owlcat/ui template. Catches crashes that
// route-level error.tsx cannot (errors in the root layout itself), so it renders
// its own <html>/<body> outside the theme/i18n providers (English, inline
// styles). Server-side detail lands in the structured log via
// instrumentation.onRequestError (@owlcat/observability); the digest links this
// screen to that log line. Next requires this FILE be a Client Component.
// Mirrors src/portal.
export { GlobalError as default } from '@owlcat/ui';
